/**
 * Maps carousel activeSlide (including infinite-loop clones) to a real content index.
 * Mirrors clone layout from useBannerElements / useBannerRowScrollTransition.
 */
export function getBannerContentIndexFromSlide(
  slideIndex: number,
  length: number,
  visibleCards: number,
  infiniteLoop: boolean
): number | null {
  if (!length) return null

  if (!infiniteLoop) {
    if (slideIndex < 0 || slideIndex >= length) return null
    return slideIndex
  }

  if (slideIndex >= visibleCards && slideIndex < visibleCards + length) {
    return slideIndex - visibleCards
  }

  if (slideIndex < visibleCards) {
    return length - visibleCards + slideIndex
  }

  if (slideIndex >= visibleCards + length) {
    return slideIndex - visibleCards - length
  }

  return null
}
